/**
 * Custom Cart Automation Script: UTV Bedrail + Equipment Rack Bracket Bundle
 * File Path: assets/gti-cart-promo.js
 * 
 * Instructions:
 * 1. Log in to Shopify Admin -> Online Store -> Themes -> Actions -> Edit Code.
 * 2. Under "Assets", click "Add a new asset". Select "Create an empty file", name it "gti-cart-promo" with a ".js" extension.
 * 3. Copy this entire script and paste it into the file. Save it.
 * 4. Open "layout/theme.liquid" and add this line just before the closing </head> or </body> tag:
 *    <script src="{{ 'gti-cart-promo.js' | asset_url }}" defer></script>
 * 5. This script supports standard Shopify AJAX endpoints. It monitors the cart state and dynamically adds, updates, or removes the required EE082 brackets as items are changed.
 */

(function() {
  const promoEl = document.getElementById('gti-promo-config');
  const BRACKET_VARIANT_ID = promoEl ? parseInt(promoEl.dataset.bracketVariantId, 10) : 43449324961881; // Fallback to live ID

  const CONFIG = {
    // Exact handles of our three UTV Bedrail Systems
    UTV_RAIL_HANDLES: [
      'john-deere-gator-utv-bed-rail-system',
      'club-car-carryall-utv-bedrail-mounting-system',
      'lowes-axis-500-utv-bedrail-mounting-system'
    ],
    // The handle of our EE082 universal bracket product
    BRACKET_HANDLE: 'mounting-bracket',
    BRACKET_VARIANT_ID: BRACKET_VARIANT_ID,
    // Explicit list of trimmer racks that require 2 brackets
    TRIMMER_RACK_HANDLES: [
      '2-place-lockable-trimmer-rack',
      '3-place-lockable-trimmer-rack',
      '4-place-lockable-trimmer-rack',
      '3-place-trimmer-rack-open-trailer',
      '2-place-trimmer-rack-open-trailer'
    ],
    // Explicitly list qualifying commercial equipment racks
    QUALIFYING_RACK_HANDLES: [
      '2-place-lockable-trimmer-rack',
      '3-place-lockable-trimmer-rack',
      '4-place-lockable-trimmer-rack',
      'lockable-backpack-blower-rack-trailer',
      '5-gallon-gas-can-lock-cage',
      '2-5-gallon-gas-can-lock-cage',
      'racing-fuel-can-lockable-cage',
      'lockable-backpack-sprayer-security-cage',
      'storage-rack',
      'lockable-multi-tool-security-cage',
      'trimmer-line-spool-rack-cutter',
      'hand-tool-rack-open-landscape-trailer',
      'backpack-sprayer-trailer-mount-rack',
      '3-place-trimmer-rack-open-trailer',
      '2-place-trimmer-rack-open-trailer',
      'lockable-d-handle-shovel-rack',
      'water-cooler-rack',
      'locking-hedge-trimmer-security-rack',
      'backpack-blower-rack-open-trailer',
      'lockable-multi-tool-rack-trailer',
      'xtreme-pro-mid-mount-hedge-trimmer-support'
    ],
    // Piranha Pressure Washer Promotion Configuration
    WASHER_VARIANT_ID: 43449230524505,
    WASHER_HANDLE: 'piranha-21v-battery-powered-mini-pressure-washer',
    WASHER_SND_HANDLE: 'piranha-21v-battery-powered-mini-pressure-washer-snd',
    WASHER_PROMO_THRESHOLD: 100000, // $1,000.00 in cents
    THROTTLE_MS: 800
  };

  let isUpdating = false;

  // Evaluates cart items to see what needs adjustment
  function evaluateCartPromotion() {
    if (isUpdating) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        let hasUTVRail = false;
        let trimmerRackCount = 0;
        let otherRackCount = 0;
        let currentBracketQty = 0;

        let qualifyingSubtotal = 0;
        let promoWasherQty = 0;
        let promoWasherKey = null;

        cart.items.forEach(item => {
          // 1. Is a UTV Bedrail present?
          if (CONFIG.UTV_RAIL_HANDLES.includes(item.handle)) {
            hasUTVRail = true;
          }

          // 2. Count current brackets in cart
          if (item.handle === CONFIG.BRACKET_HANDLE || item.variant_id === CONFIG.BRACKET_VARIANT_ID) {
            currentBracketQty = item.quantity;
          }

          // 3. Evaluate other items to see if they are qualifying equipment racks (explicit handles only, no accessories)
          const isRack = CONFIG.QUALIFYING_RACK_HANDLES.includes(item.handle);

          if (isRack) {
            // Trimmer racks require 2 brackets. Others require 1. (Explicit handle-matching)
            if (CONFIG.TRIMMER_RACK_HANDLES.includes(item.handle)) {
              trimmerRackCount += item.quantity;
            } else {
              otherRackCount += item.quantity;
            }
          }

          // 4. Calculate qualifying subtotal and identify promo washer
          const isWasher = (item.handle === CONFIG.WASHER_HANDLE || item.handle === CONFIG.WASHER_SND_HANDLE || item.variant_id === CONFIG.WASHER_VARIANT_ID);
          if (isWasher && item.properties && item.properties._promo_free_gift === 'true') {
            promoWasherQty = item.quantity;
            promoWasherKey = item.key;
          } else if (!isWasher) {
            // Include everything except the pressure washer in the qualifying subtotal
            qualifyingSubtotal += item.price * item.quantity;
          }
        });

        // Calculate the ideal bracket quantity
        let targetBracketQty = 0;
        if (hasUTVRail && (trimmerRackCount > 0 || otherRackCount > 0)) {
          targetBracketQty = (trimmerRackCount * 2) + (otherRackCount * 1);
        }

        // Calculate the ideal pressure washer quantity
        let targetWasherQty = qualifyingSubtotal >= CONFIG.WASHER_PROMO_THRESHOLD ? 1 : 0;

        // Sync items if there's any difference
        syncCartPromotions(targetBracketQty, currentBracketQty, targetWasherQty, promoWasherQty, promoWasherKey);
      })
      .catch(err => {
        console.error('[GTI Promo] Error fetching cart:', err);
      });
  }

  function toggleCheckoutButtons(disable) {
    const buttons = document.querySelectorAll('form[action="/cart"] [name="checkout"], .cart__checkout-button, .checkout-button, [href="/checkout"], .cart-drawer__footer [name="checkout"]');
    buttons.forEach(btn => {
      if (disable) {
        btn.setAttribute('disabled', 'disabled');
        btn.style.opacity = '0.5';
        btn.style.pointerEvents = 'none';
      } else {
        btn.removeAttribute('disabled');
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      }
    });
  }

  // Handles syncing of promotional items sequentially or in combination
  function syncCartPromotions(targetBracketQty, currentBracketQty, targetWasherQty, promoWasherQty, promoWasherKey) {
    const bracketDiff = (targetBracketQty !== currentBracketQty);
    const washerDiff = (targetWasherQty !== promoWasherQty);

    if (!bracketDiff && !washerDiff) {
      return; // In sync, no changes needed
    }

    if (isUpdating) return; // Prevent concurrent requests & loops
    isUpdating = true;
    toggleCheckoutButtons(true);

    // If we need to ADD the free pressure washer, we must use /cart/add.js (since update.js cannot attach properties to a new item)
    if (targetWasherQty === 1 && promoWasherQty === 0) {
      console.log('[GTI Promo] Qualifying subtotal met. Adding free Piranha pressure washer...');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: CONFIG.WASHER_VARIANT_ID,
            quantity: 1,
            properties: {
              '_promo_free_gift': 'true'
            }
          }]
        })
      })
      .then(res => res.json())
      .then(() => {
        isUpdating = false;
        // Re-evaluate cart to handle bracket adjustments in a chained step
        evaluateCartPromotion();
      })
      .catch(err => {
        console.error('[GTI Promo] Failed to add free pressure washer:', err);
        isUpdating = false;
        toggleCheckoutButtons(false);
      });
      return;
    }

    // Otherwise, we only need to update existing quantities (brackets, or removing the washer, or both)
    console.log('[GTI Promo] Syncing promo quantities in cart...');
    const updates = {};
    if (bracketDiff) {
      updates[CONFIG.BRACKET_VARIANT_ID] = targetBracketQty;
    }
    if (washerDiff && promoWasherQty > 0) {
      updates[promoWasherKey] = targetWasherQty; // Will be 0 to remove it
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    })
    .then(res => res.json())
    .then(newCart => {
      console.log('[GTI Promo] Sync complete. Refreshing UI.');
      isUpdating = false;
      toggleCheckoutButtons(false);
      
      // Fire native event or trigger theme drawer refresh
      dispatchCartUpdateEvent(newCart);
    })
    .catch(err => {
      console.error('[GTI Promo] Sync failed:', err);
      isUpdating = false;
      toggleCheckoutButtons(false);
    });
  }

  // Notifies the theme that cart contents changed, handles drawers, or reloads page
  function dispatchCartUpdateEvent(cart) {
    // 1. Dispatch custom event for AJAX drawers
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));

    // 2. Refresh page if on standard cart view or if drawer doesn't auto-update
    if (window.location.pathname === '/cart' || window.location.pathname.includes('/cart')) {
      window.location.reload();
    } else {
      // Many modern Shopify themes will react to standard event dispatches.
      // If not, a soft page reload or standard cart reload function is triggered.
      const drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
      if (drawer) {
        console.log('[GTI Promo] AJAX Drawer elements detected.');
      } else {
        // Fallback for static heads
        setTimeout(function() { window.location.reload(); }, 200);
      }
    }
  }

  // Debounce helper to prevent multiple rapid triggers during clicks
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  const debouncedEvaluation = debounce(evaluateCartPromotion, CONFIG.THROTTLE_MS);

  // Monitor DOM modifications or fetch network operations to detect Add-To-Cart actions
  document.addEventListener('DOMContentLoaded', function() {
    evaluateCartPromotion(); // Run immediately on page load

    // Intercept standard form additions or AJAX cart events
    document.addEventListener('cart:added', debouncedEvaluation);
    document.dispatchEvent(new CustomEvent('cart:updated'));

    // Listen to click on standard submit/button add forms
    document.addEventListener('click', function(e) {
      const target = e.target;
      if (target && (
        target.matches('[type="submit"][name="add"]') || 
        target.matches('.add-to-cart') || 
        target.matches('.btn--add-to-cart') ||
        target.closest('[type="submit"][name="add"]')
      )) {
        // Wait briefly for the main product to hit the cart, then check promo
        setTimeout(evaluateCartPromotion, CONFIG.THROTTLE_MS);
      }
    });

    // Intercept native fetch/XHR cart calls
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      if (typeof url === 'string' && (
        url.includes('/cart/add') || 
        url.includes('/cart/change') || 
        url.includes('/cart/update') || 
        url.includes('/cart/clear')
      ) && !isUpdating) {
        return originalFetch.apply(this, args).then(res => {
          setTimeout(evaluateCartPromotion, CONFIG.THROTTLE_MS + 200);
          return res;
        });
      }
      return originalFetch.apply(this, args);
    };
  });
})();
